export default {
    labels: {
        agreements: 'Convênios',
        searchByAgreementCode: 'Pesquisar por código do convênio',
        searchByService: 'Pesquisar por nome de serviço',
        payer: 'Operadora de saúde',
        services: 'Serviços',
        title: 'Configuração de convênio',
        basicInformation: 'Informação básica',
        regulation2275: 'Regulamento 2275',
        packageConfiguration: 'Configuração geral de envio',
        groupsConfiguration: 'Configurações de agrupamento de arquivos',
        generalAuditConditions: 'Condições gerais de auditoria',
        auditRules: 'Regras de auditoria',
        results: 'Resultados',
        yes: 'Sim',
        no: 'Não',
        active: 'Ativo',
        inactive: 'Inativo',
        email: 'E-MAIL',
        virtualDirectory: 'DIRETÓRIO VIRTUAL',
        s3: 'S3',
        api: 'API',
        sftp: 'SFTP',
        singleFile: 'Arquivo único',
        sftps3: 'SFTP/S3',
        zip: 'ZIP',
        documentaryType: 'Tipo de documento',
        groupingByCode: 'Agrupamento por código',
        validate: 'VALIDAR',
        nonValidate: 'NÃO VALIDAR',
        deleteAuditRule: 'Tem certeza de que deseja excluir a regra de auditoria?',
        pmisToValidate: 'Item para auditar',
        pos: '-',
        noPos: '-',
        deleteAuditService: 'Tem certeza de que deseja remover o serviço {name} da regra de auditoria?',
        deleteAuditProduct: 'Você tem certeza de que deseja remover o item com o nome {name} da regra de auditoria?',
        confirm: 'Esta ação não pode ser revertida',
        allServicesAdded: 'Todos os serviços foram adicionados.',
        pdf: 'PDF',
        pdfAndZip: 'PDF e ZIP',
        deleteGroup: 'Tem certeza de que deseja excluir o grupo {name}?',
        preSettlementConfiguration: 'Configuração da pasta para a relação de envio',
        dynamicFieldVariables: 'Adicionar variáveis',
    },
    supportsConfiguration: {
        title: 'Configuração de documentos',
        requiredSupportsAccount: 'Documentos necessários para conta',
        requiredSupportsCharge: 'Documentos necessários para itens de cobrança',
        search: 'Pesquise por código do item, nome do documento ou abreviatura',
        supportLevel: 'Nível de relacionamento',
        supportType: 'Tipo de documento',
        serviceType: 'Tipo de serviço',
        name: 'Nome',
        abbrevation: 'Abreviação',
        pmisCode: 'Código do item',
        productName: 'Nome do item',
        code: 'Código',
        required: 'Obrigatório',
    },
    agreements: {
        agreementCode: 'Código do convênio',
        agreementName: 'Nome do convênio',
        payer: 'Operadora',
        serviceTypes: 'Tipos de serviço',        
        normative2275: 'Regulamento 2275',
    },
    basicInformation: {
        agreementCode: 'Código do convênio',
        sponsorName: 'Operadora',
        agreementName: 'Convênio',
        taxIdentificationNumber: 'CNPJ',
        sponsorType: 'Tipo de operadora',
        sponsorCode: 'Código da operadora',
        requireConcurrentAudit: 'Concorrente',
        responsible: 'Responsável',
    },
    regulation2275: {
        activateRegulation: 'Ativar regulamento 2275',
        startDateRegulation: 'Data de início',
        cuvFormatRegulation: 'Formato CUV',
        cuvFormatTypes: {
          json: 'JSON',
          txt: 'TXT',
          jsonWithValidationResults: 'JSON com resultados de validação',
          txtWithValidationResults: 'TXT com resultados de validação',
        }
    },
    packageConfiguration: {
        deliveryChannel: 'Tipo de entrega',
        exportRoute: 'Destino',
        separateFiles: 'Separar arquivos',
        packageFolderName: 'Formato de diretório',
        packageType: 'Tipo de pacote',
        exportType: 'Tipo de exportação',
        folderName: 'Diretório de arquivos',
        formatFile: 'Nome do arquivo',
        buttons: {
            addGroup: 'Adicionar grupo',
        },
        groupName: 'Nome do grupo',
        formatFileName: 'nome do arquivo',
        supports: 'Documentos',
        copiesPlaceholder: 'Cópias',
        orderPlaceholder: 'Ordem',
        tableHeaders: {
            groupName: 'Nome do grupo',
            groupFolderName: 'diretório',
            groupFormatFile: 'Nome do arquivo do grupo',
            groupSupportsOrderAndCopies: 'Documentos, pedidos e cópias',
            groupActions: 'Ações',
        },
    },    
    zipConfiguration: {
        splitFile: 'Dividir arquivos finais',
        fileSize: 'Tamanho máximo do arquivo em MB',
        fileSizeHint: 'Tamanho de cada divisão do arquivo',
        fileSuffix: 'Sufixo de divisão',
        fileSuffixHint: 'Sufixo a ser atribuído a cada divisão do arquivo',
        splitZipFile: 'Dividir arquivo ZIP',
        zipFileSize: 'Tamanho máximo do arquivo em MB',
        zipFileSizeHint: 'Tamanho de cada divisão do arquivo ZIP',
        zipFileSuffix: 'Sufixo de divisão',
        zipFileSuffixHint: 'Sufixo a ser atribuído a cada divisão do arquivo ZIP',
        zipFolderName: 'Diretório do pacote ZIP',
        zipFormatFile: 'Nome do arquivo ZIP'
    },
    groupsConfiguration: {
        fileCode: 'Código do arquivo',
        order: 'Ordem',
        copies: 'Cópias',
        groupName: 'Nome do grupo',
        actions: 'Ações',
    },
    auditRules: {
        service: 'Serviço',
        healthPlan: 'PBS / NPBS',
        invoiceAmount: 'Valor da fatura',
        minimumAmount: 'Valor mínimo ({currency})',
        maximumAmount: 'Valor máximo ({currency})',
        auditType: 'Tipo de auditoria',
        actions: 'Ações',
        validateAmount: 'Validar valor',
        minimumAmountField: 'Quantidade mínima',
        maximumAmountField: 'Quantidade máxima',
        validateService: 'Validar serviço',
        validatePmis: 'Validar itens',
        servicesToValidate: 'Adicionar serviços',
        code: 'Código',
        name: 'Nome',
        posOrNoPos: 'PBS / NPBS',
        serviceCode: 'Código de Serviço',
        serviceName: 'Nome do Serviço',
        preSettlement: 'Pre auditoria',
    },
    buttons: {
        supportConfigurations: 'Configuração de documentos',
        assignResponsible: 'Atribuir responsável',
        edit: 'Editar',
        add: 'Adicionar',
        addPmis: 'Adicionar itens',
        addAgreement: 'Adicionar convênio',
        save: 'Salvar',
        cancel: 'Cancelar',
        next: 'Continuar',
        delete: 'Eliminar',
        back: 'Voltar',
    },
    productFinder: {
        selectPmis: 'Selecionar item',
        search: 'Pesquise por código ou nome',
        service: 'Serviço',
        healthCarePlanCoverage: 'PBS / NPBS',
        check: 'verificar',
        code: 'Código',
        name: 'Nome',
        description: 'Descrição',
    },
    messages: {
        errorUpdateAgreement: 'Erro ao atualizar as informações do convênio. Tente novamente ou entre em contato com a equipe de suporte técnico.',
    },
    buildPackages: {
      title: 'Configurações de pasta',
      agreementCode: 'Código do convênio',
      agreementName: 'Nome do convênio',
      packageFolderName: 'Diretório do pacote PDF',
      preview: 'Visualização prévia',
      multipleFiles: '*Múltiplos arquivos',
      multipleDirectory: '*Multiplas pastas',
      splitedFileWarning: '(O arquivo será dividido em partes de {size} MB)',
      duplicatedGroup: 'Já existe um grupo com o nome {name}. Deseja substituí-lo?',
      duplicatedGroupWarn: 'Esta ação substituirá as configurações do grupo existente',
      tabs: {
        folding: 'Pasta',
        supports: 'Documentos',
      },
      categories: {
        general: 'Em geral',
        INVOICES: 'Contas',
        PATIENTS: 'Pacientes',
        PROVIDER_PAYER: 'Prestador - fonte pagadora',
        PRE_SETTLEMENTS: 'Relação de envio',
      },
      fileFormatFields: {
        accountId: 'ID da conta',
        baseAccountId: 'ID da conta base',
        originEventId: 'ID do atendimento',
        agreementCode: 'Código do convênio',
        healthcarePlanCoverage: 'Plano',
        regime: 'Regime',
        lastServiceType: 'Tipo de serviço',
        lastServiceTypeDescription: 'Descrição do serviço',
        invoiceSource: 'Fonte da fatura',
        invoiceSerial: 'Série de faturas',
        electronicInvoiceNumber: 'Número da fatura digital',
        patientId: 'ID do paciente',
        patientName: 'Nome do paciente',
        payerName: 'Nome do convênio',
        providerTaxIdentificationNumber: 'CNPJ do prestador',
        providerId: 'ID do prestador',
        originInvoiceGroupId: 'Número da relação de envio',
        invoiceNumber: 'Número da nota fiscal',
        invoiceNumberRaw: 'Número da nota fiscal (sem prefixo)',
      },
    }
}
